module.exports = __webpack_public_path__ + "static/media/profile.f8f74886.svg";